<template>
  <div>
    <div class="row form-group">
      <div class="col-sm-12 col-md-6">
        <div
          v-if="!hideSelectPerPage"
          id="tickets-table_length"
          class="dataTables_length"
        >
          <span>จำนวน</span>
          <label class="d-inline-flex align-items-center">
            <b-form-select
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="ml-3"
              @change="onChangePerPage($event)"
            ></b-form-select>
          </label>
          <span class="ml-2">
            จากทั้งหมด {{ totalRecords | number('0,0') }} รายการ
          </span>
          <!--   <span class="ml-2">จากทั้งหมด 125,555 รายการ</span> -->
        </div>
      </div>
      <div class="col-sm-12 col-md-3"><slot name="prepend-search"></slot></div>
      <div class="col-sm-12 col-md-3">
        <div
          v-if="!hideSearch"
          class="input-group md-form form-sm text-md-right"
        >
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
          <input
            v-model="search"
            class="form-control my-0 py-1"
            type="search"
            placeholder="ค้นหา"
            aria-label="Search"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
          <b-table
            v-bind="$attrs"
            v-on="$listeners"
            class="table table-centered table-nowrap"
            striped
            hover
            :items="items"
            :fields="fields"
            :empty-text="'ไม่พบข้อมูล'"
            :show-empty="
              items === null ||
                items === undefined ||
                (items && items.length === 0)
            "
            :bordered="true"
            align="center"
            :filter="search"
            :perPage="perPage"
            :current-page="isTotalItems ? pageNo : 1"
          >
            <template v-slot:cell(index)="data">
              <div class="text-right">
                {{ (firstRowOnPage + data.index) | number }}
              </div>
            </template>
            <template
              v-for="(index, name) in $scopedSlots"
              v-slot:[name]="data"
            >
              <slot :name="name" v-bind="data"></slot>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <b-row v-if="items.length > 0 && !hideFooter">
      <b-col sm="12" md="6" class="mb-2">
        <div style="position: relative; top: 7px">
          รายการที่ {{ firstRowOnPage | number }} -
          {{ lastRowOnPage | number }} จากทั้งหมด
          {{ totalRecords | number('0,0') }} รายการ
        </div>
      </b-col>
      <b-col sm="12" md="6">
        <b-pagination
          :total-rows="totalRecords"
          :per-page="perPage"
          v-model="pageNo"
          @change="onClickPagination($event)"
          class="pagination pagination-rounded justify-content-end mb-2"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'TableComponent',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({
        pageNo: 1,
        perPage: 25,
        pageOptions: [10, 25, 50, 100],
        totalRecords: null,
      }),
    },
    isTotalItems: {
      type: Boolean,
      default: false,
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
    hideSelectPerPage: {
      type: Boolean,
      default: false,
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.pageNo = this.options.pageNo || 1
    this.perPage = this.options.perPage || 25
  },
  data() {
    return {
      search: '',
      index: 0,
      pageNo: this.options.pageNo || 1,
      perPage: this.options.perPage || 25,
    }
  },
  methods: {
    onClickPagination(item) {
      const pageNo = item
      this.$emit('ClickPagination', pageNo)
      if (this.isTotalItems) {
        this.pageNo = pageNo
      }
    },
    onChangePerPage(item) {
      const perPage = item
      this.$emit('ChangePerPage', perPage)
      if (this.isTotalItems) {
        this.perPage = perPage
      }
    },
  },
  computed: {
    pageOptions() {
      return this.options.pageOptions
    },
    firstRowOnPage() {
      return this.localItems.length > 0
        ? (this.pageNo - 1) * this.perPage + 1
        : 0
    },
    lastRowOnPage() {
      return this.localItems.length > 0
        ? (this.pageNo - 1) * this.perPage + this.localItems.length
        : 0
    },
    totalRecords() {
      if (this.isTotalItems === true) {
        return (this.items || []).length
      }
      return this.options.totalRecords || (this.items || []).length
    },
    localItems() {
      if (this.isTotalItems === true) {
        const firstRowOnPage = (this.pageNo - 1) * this.perPage
        const lastRowOnPage =
          (this.pageNo - 1) * this.perPage + (this.perPage - 1)
        return this.items.slice(firstRowOnPage, lastRowOnPage + 1)
      }
      return this.items
    },
  },
  watch: {
    'options.pageNo': {
      handler(val) {
        this.pageNo = val
      },
      deep: true,
    },
    'options.perPage': {
      handler(val) {
        this.perPage = val
      },
      deep: true,
    },
  },
}
</script>

<style scoped></style>
